import {
  login,
  getPhoneCode,
  logout,
  choose,
  getPicValiCode,
  // checkCompanyExists,
  checkPhoneExists,
  getTelCode,
  register,
  userInfo,
  erpUserInfo,
  setUserIdentity,
  sendLoginSmsCode,
  getCompanyInfo
} from '@/api/login-api.js'
import store from '@/store/index.js'

// 校验公司是否已注册
// export function companyIsExists(name) {
//   return checkCompanyExists(name).then(res => {
//     if (res.result === 1 && res.data.status === 'success') {
//       return false
//     } else {
//       return res.message || '校验已注册失败'
//     }
//   }).catch(err => false)
// }

// 校验电话是否已注册
export function phoneIsExists(name) {
  return checkPhoneExists(name).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      return false
    } else {
      return res.message || '校验已注册失败'
    }
  }).catch(err => false)
}

// 注册服务
export function registerServer(data) {
  return register(data).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      return true
    } else {
      return false
    }
  }).catch(err => false)
}

// 登录服务
export function loginServer(data, url) {
  return login({
    ...data,
    salt: new Date().valueOf()
  }, url).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      // 这里做一下刷新页面是否需要重定向最后一次登录人的当前页面的判断
      // 用于pre-init.js的initLocation方法
      let _old = window.localStorage.getItem('_last_staff_id')
      window.localStorage.setItem('_need_init_location', false)
      if (!_old) {
        window.localStorage.setItem('_last_staff_id', res.data.staffId)
      } else if (_old !== `${res.data.staffId}`) {
        window.localStorage.setItem('_last_staff_id', res.data.staffId)
        window.localStorage.setItem('_need_init_location', true)
      } else {
        window.localStorage.setItem('_last_staff_id', res.data.staffId)
      }

      return {
        loginIdentity: res.data.loginIdentity || 0,
        staffId: res.data.staffId
      }
    } else if (res.result === 1 && res.data.status === 'login_verify_random') { // 需要手机验证码验证
      return {
        ...res.data,
        _code: -2
      }
    } else if (res.result === 1 && res.data.status === 'login_verify_random_wrong') { // 手机验证码验证错误
      return {
        ...res.data,
        _code: -3
      }
    } else if(Number(res.data.result) === 20) { // 3次失败需要做的处理
      return {
        _code: -1,
        msg: res.data.msg
      }
    } else {
      return res.data.msg || res.message || '请求失败，请稍后重试'
    }
  }).catch(err => false)
}

// 登出服务
export function logoutServer() {
  return logout().then(res => {
    if (res.result === 1) {
      return true
    }
    return false
  }).catch(err => false)
} 

// 登录选择身份
export function loginChoose(data) {
  return choose(data).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      return true
    } else {
      return false
    }
  }).catch(err => false)
}

// 获取验证码图片
export function getValiCodePicSrc(key) {
  return getPicValiCode(key).then(res => {
    if (res.result === 1) {
      return `data:image/png;base64,${res.data}`
    } else {
      return false
    }
  }).catch(err => false)
}

// 获取手机验证码
export function getTelValiCode(data) {
  return getTelCode(data).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      return true
    } else {
      return false
    }
  }).catch(err => false)
}

// 先从服务端获取
// 服务端获取不到从本地拿
// 本地拿不到，报身份过期，跳登录

// 导出 erpUserInfo 的 Promise，供 el-select-shop 相关组件等待 RC.user 就绪
export let erpUserInfoReady = Promise.resolve();

export async function loadUserInfo({f_local, isUnlogin} = {}) {
  // 获取erp用户信息，将 promise 赋给导出变量，组件可复用同一个 promise
  erpUserInfoReady = erpUserInfo().then(erpRes => {
    if (erpRes.result === 1) {
      store.dispatch('setErpUserInfo', erpRes.data)
    } else {
      store.dispatch('setErpUserInfo', {})
    }
  }).catch(() => {
    store.dispatch('setErpUserInfo', {})
  });
  


  if (f_local) {
    // 强制从本地拿身份信息，没有拿到就跳登录页
    let _loc_info = window.localStorage.getItem('userinfo')
    if (_loc_info && _loc_info !== "{}") {
      _loc_info = JSON.parse(_loc_info);
      store.dispatch("setUserInfo", _loc_info)
      store.dispatch("setMenuConf", _loc_info.menuConf)
      return true
    } else {
      !isUnlogin && store.dispatch("LOGOUT")
      return false
    }

  } else {
    try {
      const serverRes = await userInfo();
      if (serverRes.result === 1) {
        // 直接在 serverRes.data.menuConf 上进行修改
        const commodityManagementMenu = serverRes.data.menuConf.find(menu => menu.name === '商品管理');
        if (commodityManagementMenu) {
          if (!commodityManagementMenu.children) {
            commodityManagementMenu.children = [];
          }
          let aiImagePath = '',id = 0, parentId=0;
          // 根据用户身份判断路径
          if (serverRes.data.loginIdentity == 1) { // 供销商
            aiImagePath = '/supplier/prod/ai_image_updaete';
            id = 150007;
            parentId = 15000;
          } else if (serverRes.data.loginIdentity == 2) { // 分销商
            aiImagePath = '/distributor/prod/ai_image_updaete';
            id = 2100006;
            parentId = 21000;
          }
          commodityManagementMenu.children.push({
            parentId: parentId,
            path: aiImagePath,
            id: id,
            name: 'AI改图',
            categoryName:'',
            domain:'',
          });
        }

        // 现在 serverRes.data 已经包含了修改后的 menuConf
        // 先 dispatch setUserInfo，这样 localStorage 就会存入正确的数据
        store.dispatch('setUserInfo', serverRes.data);
        
        // 然后再 dispatch setMenuConf，这步其实可以省略，因为 setUserInfo 内部已经处理了
        // 但为了逻辑清晰，可以保留
        store.dispatch('setMenuConf', serverRes.data.menuConf);
        
        return true;
      } else {
        // 从本地拿
        let _loc_info = window.localStorage.getItem('userinfo')
        if (_loc_info && _loc_info !== "{}") {
          _loc_info = JSON.parse(_loc_info);
          store.dispatch("setUserInfo", _loc_info)
          store.dispatch("setMenuConf", _loc_info.menuConf)
          return true
        } else {
          !isUnlogin && store.dispatch("LOGOUT")
          return false
        }
      }
    } catch (error) {
      console.log(error)
      store.dispatch("LOGOUT")
      return false
    }
  }
 
  

}

export const phoneCodeGet = function(params) {
  return getPhoneCode(params).then(res => {
     if (res.result === 1) {
      return res
    } else {
      return false
    }
  }).catch(err => false)
};
export const phoneLoginCodeGet = function(params) {
  return sendLoginSmsCode(params);
};

export const switchIdentity = function(loginIdentity) {
  return setUserIdentity({loginIdentity: Number(loginIdentity)}).then(res => {
    return res.result === 1
  }).catch(err => false)
}
